import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLayout from "../../components/templetes/popupLayout";
import { StyledButton } from "../../components/atoms/button";
import { ValidationInput } from "../../components/atoms/validation/ValidationInput";

const PasswordChangePopup = ({ changePassword, closePopup }) => {
  const { t } = useTranslation();
  const [validate, setValidate] = useState(false);
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmNewPw, setConfirmNewPw] = useState("");

  const onSubmit = () => {
    setValidate(true);
    if (currentPw === "" || newPw === "" || confirmNewPw === "") return;
    if (newPw !== confirmNewPw) {
      alert(t("pwChange.confirmMismatch"));
      return;
    }
    changePassword(
      {
        currentPassword: currentPw,
        newPassword: newPw,
      },
      () => {
        setValidate(false);
        closePopup();
        alert(t("pwChange.success"));
      }
    );
  };

  return (
    <>
      <PopupLayout
        theme="primary"
        data-size="lg"
        title={t("pwChange.title")}
        closePopup={closePopup}
        button={
          <StyledButton
            type="text"
            data-bg="primary"
            size="md"
            onClick={onSubmit}
          >
            {t("common.confirm")}
          </StyledButton>
        }
      >
        <div style={{ paddingLeft: "3%", paddingRight: "3%" }}>
          <ValidationInput
            label={t("pwChange.current")}
            type="password"
            value={currentPw}
            onChange={(e) => setCurrentPw(e.target.value)}
            showValidate={validate}
            invalidMsg={t("pwChange.currentRequired")}
          />
          <ValidationInput
            label={t("pwChange.new")}
            type="password"
            value={newPw}
            onChange={(e) => setNewPw(e.target.value)}
            showValidate={validate}
            invalidMsg={t("pwChange.newRequired")}
          />
          <ValidationInput
            label={t("pwChange.confirm")}
            type="password"
            value={confirmNewPw}
            onChange={(e) => setConfirmNewPw(e.target.value)}
            showValidate={validate}
            invalidMsg={t("pwChange.confirmRequired")}
          />
        </div>
      </PopupLayout>
    </>
  );
};

export default PasswordChangePopup;
